import React, { Component } from 'react'
import { Icon, Parallax } from 'react-materialize'
import Robot from './Robot'

const ASSETS = `${process.env.PUBLIC_URL}/assets`

export class Landing extends Component {
  render() {
    return (
      <div className="landing">
        <div className='thunder'>
        <img src={`${ASSETS}/light.gif`} alt="thunder-left"/>
        </div>
        <div className='thunder2'>
          <img src={`${ASSETS}/light.gif`} alt="thunder-right"/>
        </div>
        <div className="parallaxContainer">
          <Parallax imageSrc={`${ASSETS}/cyber06.jpg`} className="phoenix" />
          <div className="overlay">
            <p>React ChatBot</p>
            <div className="robot">
              <Robot />
            </div>

            <div className="adjust">
              <a
                href="http://github.com/inPhoenix"
                target="_blank"
                rel="noopener noreferrer"
                className="adjust-link"
              >
                <Icon small>code</Icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Landing
